package com.macrofocus.eflux.network.risk

import com.macrofocus.eflux.deckgl.polygonToDeckGL
import org.locationtech.jts.geom.Polygon

class RiskComponentPolygon(val riskComponent: RiskComponent, geometry: Polygon) {
    val deckglPolygon: Array<Array<DoubleArray>> = polygonToDeckGL(geometry)
}